import styles from "./ClickAndCollectCountdown.module.scss";

type Props = {
  /**
   * A string representing the collect from local time tomorrow
   */
  collectFromLocalTimeTomorrow: string;
  /**
   * A number representing how many milliseconds it is before the cutoff time
   */
  timeLeftMs: number;
};

export const ClickAndCollectCountdownUI = ({
  collectFromLocalTimeTomorrow,
  timeLeftMs,
}: Props) => {
  const h = Math.floor((timeLeftMs / (1000 * 60 * 60)) % 24);
  const m = Math.floor((timeLeftMs / (1000 * 60)) % 60);
  const s = Math.floor((timeLeftMs / 1000) % 60);

  const pluralise = (n: number, word: string) =>
    `${n} ${word}${n !== 1 ? "s" : ""}`;

  const parts = [];
  if (h) parts.push(pluralise(h, "hour"));
  if (m) parts.push(pluralise(m, "minute"));
  if (!h && m < 2 && s) parts.push(pluralise(s, "second"));

  const timeDisplay = parts.join(" ");

  return (
    <div
      className={styles.container}
      data-testid="countdown-message"
      data-component="ClickAndCollectCountdown"
    >
      Order in the next <span className={styles.time}>{timeDisplay}</span> to
      collect in-store from {collectFromLocalTimeTomorrow} tomorrow
    </div>
  );
};
